export default __webpack_public_path__ + "static/media-de@2x-77a33ae26c3d3a5943b173a749797526.png";